module.exports = __webpack_public_path__ + "static/media/fine-foods.6af80c11.png";